<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>
    <table class="table table-bordered mb-0">
      <thead>
      <tr>
        <th>Warengruppe</th>
        <th style="width: 150px;">Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="item.id || 'new-' + index">
        <td>
          <select v-model="item.product_group" class="form-control">
            <option value="">-- Bitte wählen --</option>
            <option v-for="(label, value) in productGroups" :key="value" :value="value">
              {{ label }}
            </option>
          </select>
        </td>
        <td class="text-center">
          <button :disabled="saving" class="btn btn-outline btn-danger btn-sm" type="button"
                  @click="deleteItem(index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button class="btn btn-outline btn-info btn-sm mt-2" type="button" @click="addItem">
      <i class="fa fa-plus"></i> Weitere Warengruppe hinzufügen
    </button>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";

export default {
  name: "SimulationExclusionsProduct",
  components: {VueToastr},
  data() {
    return {
      items: [],
      saving: false,
    };
  },
  props: {
    variantId: {
      type: [String, Number],
      required: true,
    },
    initialItems: {
      type: Array,
      default: () => [],
    },
    productGroups: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.items = this.initialItems.map(item => ({
      id: item.id,
      product_group: item.product_group,
    }));
  },
  methods: {
    addItem() {
      this.items.push({
        id: null,
        product_group: "",
      });
    },
    getItems() {
      return this.items
        .filter(item => item.product_group)
        .map(item => ({
          id: item.id || null,
          product_group: item.product_group,
        }));
    },
    updateItems(items) {
      this.items = items.map(item => ({
        id: item.id,
        product_group: item.product_group,
      }));
    },
    async deleteItem(index) {

      if (!confirm("Möchten Sie diesen Ausschluss wirklich löschen?")) {
        return;
      }

      this.items.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.table {
  margin-top: 10px;
}
.mt-2 {
  margin-top: 10px;
}
</style>
